import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from '../../context/AdminContext';
import '../../styles/AdminBlog.css';

export default function AdminBlogLogin() {
  const navigate = useNavigate();
  const { isAuthenticated, login, loading } = useAdmin();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [totp, setTotp] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!loading && isAuthenticated) {
      navigate('/adminblog/posts');
    }
  }, [isAuthenticated, loading, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    const result = await login(email, password, totp.trim());
    if (result.success) {
      navigate('/adminblog/posts');
    } else {
      setError(result.error || 'Invalid credentials');
    }
    setSubmitting(false);
  };

  if (loading) {
    return <div className="adminblog-loading">Loading...</div>;
  }

  return (
    <div className="adminblog-login-page">
      <div className="adminblog-login-container">
        <div className="adminblog-login-header">
          <h1>The Journal</h1>
          <p>Blog Administration</p>
        </div>
        <form className="adminblog-login-form" onSubmit={handleSubmit}>
          {error && <div className="adminblog-login-error">{error}</div>}
          <div className="adminblog-login-field">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@physiology.com"
              required
            />
          </div>
          <div className="adminblog-login-field">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="adminblog-login-field">
            <label>Authenticator code</label>
            <input
              type="text"
              inputMode="numeric"
              autoComplete="one-time-code"
              pattern="[0-9]{6}"
              maxLength={6}
              value={totp}
              onChange={(e) => setTotp(e.target.value.replace(/\D/g, ''))}
              placeholder="123456"
            />
          </div>
          <button className="adminblog-login-btn" type="submit" disabled={submitting}>
            {submitting ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
